const n="\n  userErrors {\n    code\n    field\n    message\n  }\n",e="\n  customerUserErrors {\n    code\n    field\n    message\n  }\n";export{n as CART_USER_ERRORS_FRAGMENT,e as CUSTOMER_USER_ERRORS};
//# sourceMappingURL=errors.js.map
